export const SET_SURVEY_WORKFLOW = 'DOKBOT/SET_SURVEY_WORKFLOW';
export const INIT_DOKBOT = 'DOKBOT/INIT_DOKBOT';
